/**
 * Il report di conformita' (piani Silver e superiori): un PDF con cosa e'
 * stato anonimizzato e come - categorie, occorrenze, pagine, metodi, aree da
 * controllare, impronta del documento - senza i valori originali. Lo prepara
 * il backend (POST /api/report) a ogni richiesta e non lo conserva.
 */

/** Il nome del file dall'intestazione Content-Disposition, se c'e'. */
export function nomeDaIntestazione(intestazione, ripiego = "report-conformita.pdf") {
  const m = /filename="?([^";]+)"?/i.exec(intestazione || "");
  return m ? m[1].trim() : ripiego;
}

const MESSAGGI = {
  401: "Sessione scaduta: accedi di nuovo per scaricare il report.",
  403: "Il report di conformità è compreso nei piani Silver, Gold e Platinum.",
  404: "Uno dei documenti non risulta fra i lavori del tuo account.",
  409: "Uno dei documenti non è ancora pronto: riprova fra poco.",
  410: "Uno dei documenti non è più disponibile: vengono eliminati circa un'ora dopo l'anonimizzazione.",
};

/**
 * Chiede il report dei lavori indicati e restituisce `{ blob, nome }`.
 * Gli errori portano un messaggio pronto da mostrare.
 */
export async function chiediReportConformita(jobIds, { fetchFn = fetch } = {}) {
  const ids = [...new Set((jobIds || []).filter((id) => typeof id === "string" && id.trim()))];
  if (!ids.length) throw new Error("Nessun documento per il report.");
  let r;
  try {
    r = await fetchFn("/api/report", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ job_ids: ids }),
    });
  } catch (_) {
    throw new Error("Connessione al server non riuscita. Verifica la tua connessione e riprova.");
  }
  if (!r.ok) {
    throw new Error(MESSAGGI[r.status] || "Report non disponibile al momento. Riprova fra qualche minuto.");
  }
  return { blob: await r.blob(), nome: nomeDaIntestazione(r.headers.get("Content-Disposition")) };
}
